import { endsWith } from 'lodash/fp'
import { useEffect } from 'react'
import { connect } from 'react-redux'
import { useLocation, useHistory } from 'react-router-dom'
import styled from 'styled-components'

import MoreInfoCard from 'e-submission/components/Card/MoreInfoCard'
import store from 'e-submission/store'
import { withModalToggle } from 'lib/with-hoc'
import { getToggles } from 'quick-quote/feature-toggles'

import { setAppValue } from '../../../apps/actions'

import { _Dialog } from './_Dialog'

const Component = styled(
  ({
    sections,
    isModalOpen,
    subpage,
    customButtons,
    okButton,
    cybsRetryUntilCancel,
    isWarningEdaPaymentNeeded,
    ...props
  }) => {
    const location = useLocation()
    const history = useHistory()

    const toggleModal = () => {
      if (endsWith(subpage, history.location.pathname)) {
        history.replace(history.location.pathname.replace(`/${subpage}`, ''))
      } else {
        history.push(`${history.location.pathname}/${subpage}`)
      }
      props.toggleModal()
    }

    const onClick = (evt) => {
      if (sections) {
        if (subpage === 'payment' && props.title === 'ชำระเบี้ยงวดแรก') {
          props.dispatch({ type: 'START_CYBS_CHECK_RETRY' })
        }
        toggleModal()
      }
      if (props.onClick) props.onClick(evt)
    }

    useEffect(() => {
      if (endsWith(subpage, location.pathname)) {
        props.toggleModal()
      }
    }, [])

    useEffect(() => {
      if (isModalOpen && !endsWith(subpage, location.pathname)) {
        props.toggleModal()
      } else if (!isModalOpen && endsWith(subpage, location.pathname)) {
        props.toggleModal()
      }

      if (getToggles().ENABLE_CYBERSOURCE_RETRY && isModalOpen && cybsRetryUntilCancel && subpage === 'payment') {
        if (cybsRetryUntilCancel) {
          store.dispatch(setAppValue('cybsRetryUntilCancel', false))
          toggleModal()
        }
      }
    }, [isModalOpen, location.pathname, cybsRetryUntilCancel])

    return (
      <MoreInfoCard {...props} onClick={onClick} isWarningEdaPaymentNeeded={isWarningEdaPaymentNeeded}>
        {sections && (
          <_Dialog
            {...props}
            sections={sections}
            toggleModal={toggleModal}
            isModalOpen={isModalOpen}
            subpage={subpage}
            customButtons={customButtons}
            okButton={okButton}
          />
        )}
      </MoreInfoCard>
    )
  }
)`
  .modal-header {
    .modal-title {
      flex-direction: row;
      display: flex;
    }
    .icon,
    .btn-left {
      z-index: 999;
      cursor: pointer;
      height: 40px;
    }
    span {
      margin-left: -28px;
      flex: 1 1 auto;
    }
  }
  .modal-footer {
    justify-content: space-between;
  }
`

export default (hoc) => connect(null, (dispatch) => ({ dispatch }))(withModalToggle(Component))
